import { Heading, SystemStyleObject } from "@chakra-ui/react";

type IProps = {
  sx?: SystemStyleObject;
};

const Header = (props: IProps) => {
  return (
    <Heading
      display={{ base: "none", sm: "none", md: "block" }}
      maxW={{ base: "none", md: "responsive.md" }}
      textAlign={"center"}
      fontSize={"xl"}
      color={"whiteAlpha.800"}
      mx={"auto"}
      sx={props.sx}
    >
      Unlock your personalized learning journey by creating a free account today
    </Heading>
  );
};

export default Header;
